import React from "react";

import styled from "styled-components/macro";

export default function ErrorBoundaryFallback() {
  return (
    <Wrapper>
      <p>Oh no! Something went wrong.</p>
      <p>
        If the problem persists, please get help at{" "}
        <a href="mailto:help@flocknote.com?subject=FamilyRegistrationPublicPage Error">
          help@flocknote.com
        </a>
      </p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 20px 20px;
`;
